/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ added: NonNullable<unknown>, skipped: NonNullable<unknown>, removed: NonNullable<unknown> }} Job_Form_Slot_Generation_ResultInputs */

const en_job_form_slot_generation_result = /** @type {(inputs: Job_Form_Slot_Generation_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} appointments added, ${i?.skipped} skipped (overlap), ${i?.removed} removed`)
};

const de_job_form_slot_generation_result = /** @type {(inputs: Job_Form_Slot_Generation_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} Termine angelegt, ${i?.skipped} übersprungen (Überschneidung), ${i?.removed} entfernt`)
};

/**
* | output |
* | --- |
* | "{added} appointments added, {skipped} skipped (overlap), {removed} removed" |
*
* @param {Job_Form_Slot_Generation_ResultInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_slot_generation_result = /** @type {((inputs: Job_Form_Slot_Generation_ResultInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Slot_Generation_ResultInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_slot_generation_result(inputs)
	return en_job_form_slot_generation_result(inputs)
});